import DimensiHead from "../../../../../components/categories/siakad/laporan_adab/penilaian/HomeHead";
export default function Home() {
  
  return (
    <DimensiHead />
  );
}
